import { useEffect } from 'react';

const CalendlyRedirect = () => {
    
    useEffect(() => {
        window.location.href = 'https://calendly.com/taggbox/demo?embed_domain=app.taggbox.com&embed_type=PopupText&src=onboarding&utm_campaign=calendly_Request_demo_click&month=2024-06';
    }, []);

    return null;
}

export default CalendlyRedirect;
